import type { DecisionTreeComponent } from "./decision-tree.component";
import type { PositionConfig } from "./decision-tree.models";

type LayoutOptions = Pick<
  DecisionTreeComponent,
  "hasSellout" | "hasVilcRef" | "skuRecommendationVersion"
>;

export function createDecisionTreePositions(): PositionConfig[] {
  return [
    { key: "totalSKUCount", class: "n1" },
    { key: "assessStrategicValueCount", class: "n2" },
    { key: "prioritizationFilterCount", class: "n3" },
    { key: "financialRecoveryTestCount", class: "n4" },
    { key: "maintainHighVolumeCount", class: "n5" },
    { key: "maintainLowVolumeCount", class: "n6" },
    { key: "highVolumeProfitableCount", class: "n7" },
    { key: "focusBrandCount", class: "n8" },
    { key: "lowVolumeProfitableCount", class: "n9" },
    { key: "highVolumeProfitableKeepCount", class: "n10", type: "output" },
    { key: "highVolumeProfitableDtpCount", class: "n11", type: "output" },
    { key: "growCount", class: "n12", type: "output" },
    { key: "delistCount", class: "n13", type: "output" },
    { key: "assessStrategicValuePassedCount", class: "n14" },
    { key: "assessStrategicValueFailedCount", class: "n15" },
    { key: "prioritizationFilterPassedCount", class: "n16" },
    { key: "highVolumeProfitablePassedCount", class: "n17" },
    { key: "highVolumeProfitableFailedCount", class: "n18" },
    { key: "lowVolumeProfitablePassedCount", class: "n19" },
    { key: "lowVolumeProfitableFailedCount", class: "n20" },
    { key: "lowVolumeProfitableKeepCount", class: "n21", type: "output" },
    { key: "lowVolumeProfitableDtpCount", class: "n22", type: "output" },
    { key: "focusBrandPassedCount", class: "n23" },
    { key: "focusBrandFailedCount", class: "n24" },
    { key: "prioritizationFilterFailedCount", class: "n25" },
    { key: "financialRecoveryTestFailedCount", class: "n26" },
    { key: "financialRecoveryTestPassedCount", class: "n27" },
    { key: "vilcRefCount", class: "n28" },
    { key: "vilcRefPassedCount", class: "n29" },
    { key: "vilcRefFailedCount", class: "n30" },
    { key: "isMBCount", class: "n31" },
    { key: "isMBPassedCount", class: "n32" },
    { key: "isMBFailedCount", class: "n33" },
    { key: "volumeRetentionTestCount", class: "n34" },
    { key: "volumeRetentionTestPassedCount", class: "n35" },
    { key: "volumeRetentionTestFailedCount", class: "n36" },
  ];
}

export function getDecisionTreePositions(
  allPositions: PositionConfig[],
  options: LayoutOptions,
): PositionConfig[] {
  return allPositions
    .filter(
      (pos) =>
        options.hasVilcRef ||
        ![
          "n28",
          "n29",
          "n30",
          "n31",
          "n32",
          "n33",
          "n34",
          "n35",
          "n36",
        ].includes(pos.class),
    )
    .filter(
      (pos) => options.hasSellout || !["n4", "n26", "n27"].includes(pos.class),
    )
    .map((pos) => {
      if (options.skuRecommendationVersion === "V3") {
        if (pos.key === "highVolumeProfitableDtpCount") {
          return { ...pos, key: "highVolumeProfitableOptimizeCount" };
        }
        if (pos.key === "growCount") {
          return { ...pos, key: "accelerateCount" };
        }
        if (pos.key === "lowVolumeProfitableDtpCount") {
          return { ...pos, key: "lowVolumeProfitableOptimizeCount" };
        }
      }
      return pos;
    });
}
